import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import { Header } from "./components";
import { Footer } from './components'

function App() {
	return (
		<>
			<Header />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/ueber-uns" element={<About />}/>
			</Routes>
			<Footer />
		</>
	);
}

export default App;
